__turbopack_context__.v({
  "awards-title": "style-module-scss-module__rg8BDW__awards-title",
  "component": "style-module-scss-module__rg8BDW__component",
});
